import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { networkRequest } from '@tencent/ark-request';
import { getPlaceholderPictureSafe_3x } from '@tencent/docs-design-resources/pc/png@3x/cdn-function-export';
import { isAudioLike, isVideoLike } from '@tencent/docs-mime-types';
import merge from 'lodash.merge';
import { getXsrfToken } from "../../cgi/cookies";
import { DriveFileType } from "../../model/drive-file";
import { fetchFileInfo, fromFileInfoResp, isTransformDriveFile } from "../file-info";
import { Backend } from "../../types/backend";
/**
 * DriveFile Data Transfer Object - Online 场景下的 DriveFileDTO
 *
 * use case:
 * ```typescript
 *  const driveFileDTO = new DriveFileDTO(params);
 *  // 获取基本信息
 *  await driveFileDTO.fetchDriveFile();
 *  // 获取 previewInfo 增量信息
 *  await driveFileDTO.loadIncrementalData({ previewInfo: true });
 *  // 返回烹饪后的数据对象
 *  return driveFileDTO.driveFile;
 * ```
 */
export var DriveFileDTO = /*#__PURE__*/function () {
  function DriveFileDTO(params) {
    _classCallCheck(this, DriveFileDTO);
    // 保存的 driveFile 数据模型
    _defineProperty(this, "driveFile", void 0);
    // 用于获取 driveFile 的接口参数
    _defineProperty(this, "params", void 0);
    if (!params) throw new Error('params required');

    // 兼容旧版本的参数  Backend.FileInfoReq。
    if ('fileId' in params) {
      var fileId = params.fileId,
        objKey = params.objKey;
      this.params = {
        id: fileId,
        hostId: objKey
      };
    } else {
      this.params = params;
    }
  }

  /**
   * 获取 DriveFile，并保存起来
   */
  _createClass(DriveFileDTO, [{
    key: "fetchDriveFile",
    value: function () {
      var _fetchDriveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this = this;
        var getDriveFile;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              getDriveFile = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var resp, error;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!isTransformDriveFile(_this.params.driveFileInfo)) {
                          _context.next = 2;
                          break;
                        }
                        return _context.abrupt("return", _this.params.driveFileInfo);
                      case 2:
                        if (!_this.params.driveFileInfo) {
                          _context.next = 4;
                          break;
                        }
                        return _context.abrupt("return", fromFileInfoResp(_this.params.driveFileInfo));
                      case 4:
                        _context.next = 6;
                        return fetchFileInfo(_this.genRequestDataByParams(_this.params));
                      case 6:
                        resp = _context.sent;
                        if (!(resp.retcode !== Backend.RetCode.SUCCESS)) {
                          _context.next = 11;
                          break;
                        }
                        error = new Error('请求 fileInfo 接口失败'); // @ts-ignore;
                        error.data = resp;
                        throw error;
                      case 11:
                        return _context.abrupt("return", fromFileInfoResp(resp));
                      case 12:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function getDriveFile() {
                  return _ref.apply(this, arguments);
                };
              }();
              _context2.next = 3;
              return getDriveFile();
            case 3:
              this.driveFile = _context2.sent;
              return _context2.abrupt("return", this.driveFile);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDriveFile() {
        return _fetchDriveFile.apply(this, arguments);
      }
      return fetchDriveFile;
    }()
    /**
     * 增量加载 DriveFile 内容
     * @param config 增量参数配置
     */
  }, {
    key: "loadIncrementalData",
    value: function () {
      var _loadIncrementalData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(config) {
        var _this2 = this;
        var driveFile, safeLoadData, loadPreviewInfo, loadDownloadInfo, loadPreviewInfoCanTranscode;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              driveFile = this.driveFile; // 安全的获取数据，当接口报错，不应该影响其他增量数据的获取
              safeLoadData = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(loader) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return loader.call(_this2);
                      case 3:
                        _context3.next = 8;
                        break;
                      case 5:
                        _context3.prev = 5;
                        _context3.t0 = _context3["catch"](0);
                        console.warn("drive-api:drive-file-dto:\u589E\u91CF\u52A0\u8F7D ".concat(loader.name, " \u5931\u8D25"), _context3.t0);
                      case 8:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[0, 5]]);
                }));
                return function safeLoadData(_x2) {
                  return _ref2.apply(this, arguments);
                };
              }(); // 加载 previewInfo
              loadPreviewInfo = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  var previewInfo, _data$result$detail$, _yield$_this2$request, data, _config$previewInfoRe, _yield$_this2$request2, _data;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!driveFile.clientId) {
                          _context4.next = 8;
                          break;
                        }
                        _context4.next = 3;
                        return _this2.requestAttachmentInfo(driveFile.id);
                      case 3:
                        _yield$_this2$request = _context4.sent;
                        data = _yield$_this2$request.data;
                        previewInfo = {
                          // 插件需要展示默认的兜底图
                          url: ((_data$result$detail$ = data.result.detail[0]) === null || _data$result$detail$ === void 0 ? void 0 : _data$result$detail$.preview_url) || getPlaceholderPictureSafe_3x(),
                          imageMediaMetadata: null,
                          videoMediaMetadata: {
                            width: 0,
                            height: 0,
                            durationSeconds: 0,
                            videoUrl: {}
                          },
                          audioMediaMetadata: {
                            durationSeconds: 0
                          }
                        };
                        _context4.next = 17;
                        break;
                      case 8:
                        if (!_this2.params.queryData) {
                          _context4.next = 12;
                          break;
                        }
                        previewInfo = _this2.transformQueryToPreviewInfo(_this2.params.queryData);
                        _context4.next = 17;
                        break;
                      case 12:
                        _context4.next = 14;
                        return _this2.requestPreviewInfo({
                          file: driveFile,
                          password: (_config$previewInfoRe = config.previewInfoReqParams) === null || _config$previewInfoRe === void 0 ? void 0 : _config$previewInfoRe.password
                        });
                      case 14:
                        _yield$_this2$request2 = _context4.sent;
                        _data = _yield$_this2$request2.data;
                        previewInfo = _this2.transformQueryToPreviewInfo(_data.result);
                      case 17:
                        Object.assign(_this2.driveFile, {
                          previewInfo: previewInfo
                        });
                      case 18:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function loadPreviewInfo() {
                  return _ref3.apply(this, arguments);
                };
              }(); // 加载 downloadInfo
              loadDownloadInfo = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                  var _yield$_this2$request3, data, downloadInfo;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this2.requestDownloadInfo({
                          file: _this2.driveFile
                        });
                      case 2:
                        _yield$_this2$request3 = _context5.sent;
                        data = _yield$_this2$request3.data;
                        downloadInfo = {
                          url: data === null || data === void 0 ? void 0 : data.result.downloadUrl
                        };
                        Object.assign(_this2.driveFile, {
                          downloadInfo: downloadInfo
                        });
                      case 6:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function loadDownloadInfo() {
                  return _ref4.apply(this, arguments);
                };
              }(); // 加载 previewInfo canTranscode
              loadPreviewInfoCanTranscode = /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                  var _yield$_this2$request4, result, canTranscode;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return _this2.requestTranscodeInfo({
                          file: _this2.driveFile
                        });
                      case 2:
                        _yield$_this2$request4 = _context6.sent;
                        result = _yield$_this2$request4.data.result;
                        canTranscode = _this2.transformMediaInfoToCanTranscode(result); // 音频
                        if (isAudioLike(driveFile.mimeType)) {
                          merge(_this2.driveFile, {
                            previewInfo: {
                              audioMediaMetadata: {
                                canTranscode: canTranscode
                              }
                            }
                          });
                        }

                        // 视频
                        if (isVideoLike(driveFile.mimeType)) {
                          merge(_this2.driveFile, {
                            previewInfo: {
                              videoMediaMetadata: {
                                canTranscode: canTranscode
                              }
                            }
                          });
                        }
                      case 7:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function loadPreviewInfoCanTranscode() {
                  return _ref5.apply(this, arguments);
                };
              }();
              if (!config.previewInfo) {
                _context7.next = 8;
                break;
              }
              _context7.next = 8;
              return safeLoadData(loadPreviewInfo);
            case 8:
              if (!config.downloadInfo) {
                _context7.next = 11;
                break;
              }
              _context7.next = 11;
              return safeLoadData(loadDownloadInfo);
            case 11:
              if (!config.previewInfoCanTranscode) {
                _context7.next = 14;
                break;
              }
              _context7.next = 14;
              return safeLoadData(loadPreviewInfoCanTranscode);
            case 14:
              return _context7.abrupt("return", this.driveFile);
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function loadIncrementalData(_x) {
        return _loadIncrementalData.apply(this, arguments);
      }
      return loadIncrementalData;
    }()
    /**
     * 数据转换：query 接口数据 → DriveFile['previewInfo']
     */
  }, {
    key: "transformQueryToPreviewInfo",
    value: function transformQueryToPreviewInfo(raw) {
      var _transcodeTypeMap2Vid, _transcode_detail$0$m, _transcode_detail$0$m2;
      // 格式化各品类的 previewUrl
      var formatPreviewUrl = function formatPreviewUrl(url) {
        /**
         * @xcatliu 特殊逻辑：pdf 设置 client=drive
         * @jerrychuang 梳理这部分特殊逻辑背景：
         * 1. 2022年 9 月 Drive 接 PDF 需求
         * 2. PDF 前端开发认为全品类 previewUrl 中的 client=preview 是错误用法，PDF 不愿意一错再错，要改成 client=drive
         * 3. previewUrl 是 query 接口返回，drive 后台同学表示要给 pdf 做特定逻辑很恶心。
         * 4. 最后 drive 前端同学妥协，针对 pdf 把 client 参数改成 drive。
         * 5. client=drive，给到 PDF 表示是从 drive 来的预览场景，然后做一些特定化界面定制。
         */
        // TODO 这里私有化有特殊处理，在后面 CB 合流的时候，再来参考私有化改掉这里硬编码，换成配置下发。
        // eslint-disable-next-line @tencent/tdoc-standalone/no-use-uri-like-literal
        if (url.startsWith('https://docs.qq.com/pdf/')) {
          var newUrl = new URL(url);
          newUrl.searchParams.set('client', 'drive');
          return newUrl.toString();
        }
        return url;
      };
      var prefixProtocol = function prefixProtocol(url) {
        return url.replace(/(https?:\/\/)+|\/\//, 'https://');
      };
      var transcodeTypeMap2VideoUrlKey = (_transcodeTypeMap2Vid = {}, _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP3Original, 'origin'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4Original, 'origin'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4FLU, 'v480p'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4HD, 'v720p'), _defineProperty(_transcodeTypeMap2Vid, Backend.TranscodeType.MP4FHD, 'v1080p'), _transcodeTypeMap2Vid);
      var previewInfo = {
        // 这里需要集中特殊处理一下后台返回的预览链接
        url: raw.preview_url ? formatPreviewUrl(prefixProtocol(raw.preview_url)) : '',
        // 预览 office 文档时 iframe 内嵌文档的 file_id，用于「转在线编辑」时调用生成副本接口
        documentMetadata: {
          // 自研预览的腾讯文档 fileId
          tdocsFileId: raw.file_id
        },
        videoMediaMetadata: {
          width: 0,
          height: 0,
          durationSeconds: 0,
          videoUrl: {}
        },
        audioMediaMetadata: {
          durationSeconds: 0
        },
        imageMediaMetadata: null
      };
      if (raw.transcode_detail.length === 0) return previewInfo;

      // eslint-disable-next-line @typescript-eslint/naming-convention
      var transcode_detail = raw.transcode_detail;
      if ((_transcode_detail$0$m = transcode_detail[0].media) !== null && _transcode_detail$0$m !== void 0 && _transcode_detail$0$m.video) {
        previewInfo.videoMediaMetadata = {
          width: 0,
          height: 0,
          durationSeconds: parseInt(transcode_detail[0].media.video.length, 10),
          videoUrl: {}
        };

        // eslint-disable-next-line @typescript-eslint/naming-convention
        var _iterator = _createForOfIteratorHelper(transcode_detail),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _step.value,
              streaming_url = _step$value.streaming_url,
              transcode_type = _step$value.transcode_type,
              status = _step$value.status;
            if (status === Backend.TranscodeStatus.Success) {
              var type = transcodeTypeMap2VideoUrlKey[transcode_type];
              previewInfo.videoMediaMetadata.videoUrl[type] = streaming_url;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if ((_transcode_detail$0$m2 = transcode_detail[0].media) !== null && _transcode_detail$0$m2 !== void 0 && _transcode_detail$0$m2.audio) {
        previewInfo.audioMediaMetadata = {
          durationSeconds: parseInt(transcode_detail[0].media.audio.length, 10)
        };
      }
      return previewInfo;
    }

    /**
     * drive/mediainfo 接口响应转成 DriveFile.previewInfo[videoMediaMetadata|audioMediaMetadata].canTranscode
     */
  }, {
    key: "transformMediaInfoToCanTranscode",
    value: function transformMediaInfoToCanTranscode(raw) {
      var _keyMap;
      var keyMap = (_keyMap = {}, _defineProperty(_keyMap, Backend.TranscodeType.MP3Original, 'origin'), _defineProperty(_keyMap, Backend.TranscodeType.MP4Original, 'origin'), _defineProperty(_keyMap, Backend.TranscodeType.MP4FLU, 'v480p'), _defineProperty(_keyMap, Backend.TranscodeType.MP4HD, 'v720p'), _defineProperty(_keyMap, Backend.TranscodeType.MP4FHD, 'v1080p'), _keyMap);
      var canTranscode = {};
      raw.can_transcode_type.forEach(function (type) {
        var key = keyMap[type];
        if (key) canTranscode[key] = true;
      });
      return canTranscode;
    }

    /**
     * 构造接口入参，理由见 this.genRequestDataByParams 注释
     * 查询附件时：file_id = hostId（即 padId）, obj_key = driveId（即objKey的值）
     * 查询云文件时：file_id = driveId(即objKey的值)
     */
  }, {
    key: "getRequestDataByDriveFile",
    value: function getRequestDataByDriveFile(file) {
      var _DriveFileType$CLOUD$;
      return (_DriveFileType$CLOUD$ = {}, _defineProperty(_DriveFileType$CLOUD$, DriveFileType.CLOUD, {
        file_id: file.id
      }), _defineProperty(_DriveFileType$CLOUD$, DriveFileType.ATTACHMENT, {
        file_id: file.hostId,
        obj_key: file.id
      }), _DriveFileType$CLOUD$)[file.driveFileType] || {};
    }

    /**
     * 构造 drive 接口查询参数，适用于类似接口：drive/fileInfo, drive/query, drive/downloadUrl 等
     * 这里有点费解，是因为接口对于 Drive云文件和 Drive附件入参有冲突逻辑，并且改不动：
     * 1. Drive 云文件：fileId 代表 DriveFile 的唯一标识。
     * 2. Drive 附件：fileId 代表所属文档的唯一标识，另起 objKey 作为文件的唯一标识。
     */
  }, {
    key: "genRequestDataByParams",
    value: function genRequestDataByParams(params) {
      var id = params.id,
        hostId = params.hostId;
      return hostId ? {
        objKey: id,
        fileId: hostId
      } : {
        fileId: id
      };
    }

    /**
     * 请求 /v2/drive/preview/query 接口
     */
  }, {
    key: "requestPreviewInfo",
    value: function () {
      var _requestPreviewInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref6) {
        var _this3 = this;
        var file, password, _ref6$shouldRetry, shouldRetry, _ref6$retryCount, retryCount, _ref6$retryDuration, retryDuration, send, wait, tryCount, _yield$send, rsp, error, _rsp2, result;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              file = _ref6.file, password = _ref6.password, _ref6$shouldRetry = _ref6.shouldRetry, shouldRetry = _ref6$shouldRetry === void 0 ? false : _ref6$shouldRetry, _ref6$retryCount = _ref6.retryCount, retryCount = _ref6$retryCount === void 0 ? 60 : _ref6$retryCount, _ref6$retryDuration = _ref6.retryDuration, retryDuration = _ref6$retryDuration === void 0 ? 1000 : _ref6$retryDuration;
              send = /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                  var data, _rsp;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.prev = 0;
                        data = Object.assign(_this3.getRequestDataByDriveFile(file), {
                          password: password,
                          should_retry: shouldRetry
                        });
                        _context8.next = 4;
                        return networkRequest.request({
                          url: "/v2/drive/preview/query?xsrf=".concat(getXsrfToken()),
                          method: 'POST',
                          data: data,
                          // 判定请求是否需要重试
                          errorFilter: function errorFilter(error) {
                            console.error("[\u8BF7\u6C42\u91CD\u8BD5]: ".concat(error));
                            return /Network\sError|Request\saborted|timeout/.test(error.message || '');
                          }
                        }).catch(function (e) {
                          throw new Error(e);
                        });
                      case 4:
                        _rsp = _context8.sent;
                        // eslint-disable-next-line no-param-reassign
                        shouldRetry && (shouldRetry = false);
                        return _context8.abrupt("return", {
                          rsp: _rsp
                        });
                      case 9:
                        _context8.prev = 9;
                        _context8.t0 = _context8["catch"](0);
                        return _context8.abrupt("return", {
                          error: new Error(_context8.t0)
                        });
                      case 12:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8, null, [[0, 9]]);
                }));
                return function send() {
                  return _ref7.apply(this, arguments);
                };
              }();
              wait = /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(time) {
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        return _context9.abrupt("return", new Promise(function (resolve) {
                          return setTimeout(resolve, time);
                        }));
                      case 1:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function wait(_x4) {
                  return _ref8.apply(this, arguments);
                };
              }();
              tryCount = retryCount;
              _context10.next = 6;
              return send();
            case 6:
              _yield$send = _context10.sent;
              rsp = _yield$send.rsp;
              error = _yield$send.error;
            case 9:
              if (!(tryCount -= 1)) {
                _context10.next = 23;
                break;
              }
              if (!(error || ((_rsp2 = rsp) === null || _rsp2 === void 0 ? void 0 : _rsp2.data.retcode) === Backend.RetCode.NOT_FINISH)) {
                _context10.next = 20;
                break;
              }
              _context10.next = 13;
              return wait(retryDuration);
            case 13:
              _context10.next = 15;
              return send();
            case 15:
              result = _context10.sent;
              rsp = result.rsp;
              error = result.error;
              _context10.next = 21;
              break;
            case 20:
              return _context10.abrupt("break", 23);
            case 21:
              _context10.next = 9;
              break;
            case 23:
              if (!(!rsp || error)) {
                _context10.next = 25;
                break;
              }
              throw error;
            case 25:
              if (!(rsp.data.retcode !== Backend.RetCode.SUCCESS)) {
                _context10.next = 27;
                break;
              }
              throw rsp;
            case 27:
              return _context10.abrupt("return", rsp);
            case 28:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function requestPreviewInfo(_x3) {
        return _requestPreviewInfo.apply(this, arguments);
      }
      return requestPreviewInfo;
    }()
    /**
     * 请求 /v2/attachment/list 接口
     */
  }, {
    key: "requestAttachmentInfo",
    value: function () {
      var _requestAttachmentInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(fileId) {
        var rsp;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return networkRequest.request({
                url: "/v2/attachment/list?xsrf=".concat(getXsrfToken()),
                method: 'POST',
                data: {
                  file_id: fileId,
                  access_type: Backend.AccessType.PREVIEW,
                  // limit 暂时只支持单个附件
                  limit: 1
                }
              });
            case 2:
              rsp = _context11.sent;
              if (!(rsp.data.retcode !== Backend.RetCode.SUCCESS)) {
                _context11.next = 5;
                break;
              }
              throw rsp;
            case 5:
              return _context11.abrupt("return", rsp);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function requestAttachmentInfo(_x5) {
        return _requestAttachmentInfo.apply(this, arguments);
      }
      return requestAttachmentInfo;
    }()
    /**
     * 请求 /v2/drive/downloadURL 接口
     */
  }, {
    key: "requestDownloadInfo",
    value: function () {
      var _requestDownloadInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref9) {
        var file, rsp;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              file = _ref9.file;
              _context12.next = 3;
              return networkRequest.request({
                url: "/v2/drive/downloadURL?xsrf=".concat(getXsrfToken()),
                method: 'POST',
                data: this.getRequestDataByDriveFile(file)
              }).catch(function (e) {
                throw new Error(e);
              });
            case 3:
              rsp = _context12.sent;
              if (!(rsp.data.retcode !== Backend.RetCode.SUCCESS)) {
                _context12.next = 6;
                break;
              }
              throw rsp;
            case 6:
              return _context12.abrupt("return", rsp);
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function requestDownloadInfo(_x6) {
        return _requestDownloadInfo.apply(this, arguments);
      }
      return requestDownloadInfo;
    }()
    /**
     * 请求 /api/drive/mediainfo 接口
     */
  }, {
    key: "requestTranscodeInfo",
    value: function () {
      var _requestTranscodeInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref10) {
        var file, rsp;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              file = _ref10.file;
              _context13.next = 3;
              return networkRequest.request({
                url: "/api/drive/mediainfo?xsrf=".concat(getXsrfToken()),
                method: 'POST',
                data: this.getRequestDataByDriveFile(file)
              }).catch(function (e) {
                throw new Error(e);
              });
            case 3:
              rsp = _context13.sent;
              if (!(rsp.data.retcode !== Backend.RetCode.SUCCESS)) {
                _context13.next = 6;
                break;
              }
              throw rsp;
            case 6:
              return _context13.abrupt("return", rsp);
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function requestTranscodeInfo(_x7) {
        return _requestTranscodeInfo.apply(this, arguments);
      }
      return requestTranscodeInfo;
    }()
  }]);
  return DriveFileDTO;
}();
//# sourceMappingURL=drive-file-dto.js.map